module.exports = __webpack_public_path__ + "static/media/fasad5.6274253e.jpeg";